import Button from "devextreme-react/button";
import Popup, { ToolbarItem } from "devextreme-react/popup";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadPopupPanel } from "../../../../components";
import { KindOfOrder } from "../../../../types/enums";
import { useGetMessages } from "../api/get-messages";
import { CommunicationButtonProps } from "../types/CommunicationButtonProps";
import MessageGrid from "./MessageGrid";


export default function CommunicationButton(props: CommunicationButtonProps) {

	const location = useLocation();
	const navigate = useNavigate();

	const [popupState, setPopupState] = useState<{ visible: boolean, messageID?: number, messageText?: string}>({ visible: false });

	const messages = useGetMessages(props.retailOrderID, KindOfOrder.RetailOrder, popupState.visible);

	useEffect(() => {
		if (location.state?.messageID !== undefined || location.state?.messageText !== undefined) {
			setPopupState({ visible: true, messageID: location.state?.messageID, messageText: location.state?.messageText});
			navigate(location.pathname, { replace: true, state: {} }); // clear location state
		}
	}, [location.state?.messageID, location.state?.messageText]);

	return (
		<>
			<Button
				elementAttr={{ 'data-testid': 'btn-communication' }}
				disabled={popupState.visible}
				onClick={() => setPopupState({ visible: true })}
			>
				<i className="dx-icon dx-icon-Inscyth-Communication"><span className="path1"></span><span className="path2"></span><span className="path3"></span></i>
				Communication
			</Button>
			<Popup
				title="Communication"
				visible={popupState.visible}
				hideOnOutsideClick={true}
				onHiding={() => setPopupState({ visible: false })}
			>
				<ToolbarItem
					options={{
						icon: 'dx-icon dx-icon-close',
						onClick: () => setPopupState({ visible: false })
					}}
					widget="dxButton"
					location="after"
				/>
				{
					popupState.visible &&
					<MessageGrid
						messages={messages.data}
						orderID={props.retailOrderID}
						kindOfOrder={KindOfOrder.RetailOrder}
						emailSubject={props.emailSubject}
						disableSMS={props.disableSMS}
						onMessageCreated={props.onMessageCreated}
						messageID={popupState.messageID}
						messageText={popupState.messageText}
					/>
				}

				<LoadPopupPanel visible={messages.isLoading}></LoadPopupPanel>
			</Popup>
		</>
	)
}
